module.exports = __webpack_public_path__ + "static/media/mobile.6b6b9ec7.png";